/* eslint-disable @typescript-eslint/no-var-requires */
import React from "react";
import { BrowserView, MobileView } from "react-device-detect";
import "./styles.scss";

const apple = require("../../assets/img/apple_bt@2x.png").default;
const google = require("../../assets/img/googleplay_bt@2x.png").default;

interface AppStoreLinksProps {
    linkTo: () => string;
}

const AppStoreLinks = (props: AppStoreLinksProps) => (
    <>
        <MobileView>
            <div className="store">
                <a href={props.linkTo()} target="_blank" rel="noreferrer">
                    <img src={apple} />
                </a>
                <a href={props.linkTo()} target="_blank" rel="noreferrer">
                    <img src={google} />
                </a>
            </div>
        </MobileView>
        <BrowserView>
            <div className="qr">
                <img
                    src={`https://chart.googleapis.com/chart?cht=qr&chs=230x230&chl=${encodeURIComponent(
                        props.linkTo()
                    )}?authuser=0&choe=UTF-8`}
                />
            </div>
            <p className="qr-cap">
                お使いのデバイスによって
                <br />
                <a href={props.linkTo()} target="_blank" rel="noreferrer">
                    AppStore
                </a>
                、または
                <a href={props.linkTo()} target="_blank" rel="noreferrer">
                    GooglePlay
                </a>
                へ移動します。
            </p>
        </BrowserView>
    </>
);

export default AppStoreLinks;
